import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import {
  CompleteAdventDoorMutation,
  CompleteAdventDoorMutationVariables,
} from "../api/types";
import { DoorMechanicResponse } from "../lib/advent-door-mechanics";
import { COMPLETE_ADVENT_DOOR } from "utility/graphQl/mutation";

/**
 * Records a door's completion. The payload's door and campaign share the
 * calendar query's cache ids, so the tile, counter and sheet all update
 * from the response. Rejects on any GraphQL error.
 */
export default function useCompleteAdventDoor() {
  const [complete] = useMutation<
    CompleteAdventDoorMutation,
    CompleteAdventDoorMutationVariables
  >(COMPLETE_ADVENT_DOOR);

  return useCallback(
    async (doorId: string, response: DoorMechanicResponse | null) => {
      const variables: CompleteAdventDoorMutationVariables =
        response === null
          ? { doorId }
          : { doorId, response: JSON.stringify(response) };
      const result = await complete({ variables });
      if (!result.data?.completeAdventDoor?.ok) {
        throw new Error(`completeAdventDoor was not ok for door ${doorId}`);
      }
    },
    [complete]
  );
}
